<template>
    <v-btn
        id="gtm-plotcard-cta-favorite"
        class="favorite-cta"
        :class="{
            'preview': location === 'preview',
            'title': location === 'title'
        }"
        :fab="location === 'header'"
        :elevation="location === 'header' ? 2 : 0"
        small
        icon
        @click.prevent="toggleFavorite()"
    >
        <v-icon
            class="icon"
            :class="{
                'active-heart icon-heart': isFavorite,
                'icon-empty-heart' : !isFavorite,
                'h2': location === 'title'
            }"
        />
    </v-btn>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import { mapGetters } from 'vuex';

    export default {
        name: 'Favorite',
        props: {
            data: {
                type: Object,
                required: true
            },
            location: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapGetters([
                'isLocalstorageAvailable'
            ]),
            programUuid() {
                return this.$route.query.id;
            },
            promoterUuid() {
                return this.$route.query.key;
            },
            favoriteKey() {
                return `favorite-${this.programUuid}`;
            },
            plotId() {
                if (this.$props.data.link) {
                    let url = new URL(this.$props.data.link);
                    return url.searchParams.get('id');
                }
                return null;
            },
            favoriteList: {
                get() {
                    return this.plotFavList;
                },
                set(newValue) {
                    localStorage.setItem(this.favoriteKey, JSON.stringify(newValue));
                    this.plotFavList = JSON.parse(localStorage.getItem(this.favoriteKey));
                }
            }
        },
        data() {
            return {
                isFavorite: false,
                plotFavList: []
            }
        },
        mounted() {
            if (this.isLocalstorageAvailable)
                this.plotFavList = localStorage.getItem(this.favoriteKey) ? JSON.parse(localStorage.getItem(this.favoriteKey)) : [];
             if (this.favoriteList && this.plotId) {
                if (this.favoriteList.includes(this.plotId))
                    this.isFavorite = true;
                else
                    this.isFavorite = false;
            } else
                this.isFavorite = false;
        },
        methods: {
            toggleFavorite() {
                if (!this.isFavorite) {
                    var plotList = this.favoriteList ? this.favoriteList : [];
                    plotList.push(this.plotId);
                    this.favoriteList = plotList;
                    this.displayFavoriteBanner();
                    this.isFavorite = true;
                }
                else if (this.plotId) {
                    var plotList = this.favoriteList.filter(plotId => {
                        return plotId !== this.plotId
                    });
                    this.favoriteList = plotList;
                    this.isFavorite = false;
                }

                if (this.$props.data.filters && this.$props.data.filters.isFavorite) {
                    EventBus.$emit('cutawayFilterFavorite', this.$props.data.filters.isFavorite);
                    this.$emit('close-popup');
                }
                EventBus.$emit('updatePlotFavorites', this.favoriteList);
            },
            displayFavoriteBanner() {
                let localStorageKey = `favorite-banner-${this.programUuid}-${this.promoterUuid}`;
                let nextDisplayDate = this.isLocalstorageAvailable ? localStorage.getItem(localStorageKey) : null;
                let today = new Date().getTime();
                if (!nextDisplayDate || nextDisplayDate <= today) {
                    // 30 days between each time the banner is displayed
                    let lifeCycle = 30 * 24 * 60 * 60 * 1000;
                    let nextDate = new Date(new Date().getTime() + lifeCycle);
                    if (this.isLocalstorageAvailable)
                        localStorage.setItem(localStorageKey, nextDate.getTime());
                    EventBus.$emit('displayFlashMessage', this.$t("flashMessage.favorite"));
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .favorite-cta {
        width: 32px;
        height: 32px;
        position: absolute;
        &.preview {
            top: 4px;
            right: 4px;
            pointer-events: auto;
        }
        &.title {
            top: 12px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/plotInformation/components/Favorite.vue